import * as React from 'react';
import { connect } from 'react-redux';

import LinearProgress from '@material-ui/core/LinearProgress';

import CommunicationTotal from './CommunicationTotal';
import CommunicationExpansionPanel from './CommunicationExpansionPanel';
import EmptyData from '../EmptyData/EmptyData';

import * as CommunicationCreator from '../../creators/communicationMountTab';
import {
  communicationData$,
  isLoadingCommunication$,
  hasCommunicationData$,
} from '../../selectors/communication';

import State from '../../interfaces/states/State';

import CommunicationData from '../../interfaces/CommunicationData';

import './style.scss';

interface DispatchProps {
  communicationMountTab: () => void;
}

interface OwnProps {
  communicationData: CommunicationData;
  isLoading: boolean;
  hasCommunicationData: boolean;
}

interface Props extends DispatchProps, OwnProps {}

const Communication = (props: Props) => {

  const {
    isLoading,
    communicationData,
    hasCommunicationData,
    communicationMountTab,
  } = props;

  React.useEffect(() => communicationMountTab(), []);

  return(
    <section className='communication-container d-flex flex-column'>
      {
        isLoading ?
          <div className='d-flex align-center justify-center'>
            <div className='loader-container communication-loader' >
              <LinearProgress color='primary' />
            </div>
          </div> :

          hasCommunicationData ?
            <React.Fragment>
              <CommunicationTotal communicationData={communicationData} />
              <CommunicationExpansionPanel />
            </React.Fragment>
            :
            <EmptyData
              bigImageForTab
              message='No data found for Communication' />
      }
    </section>
  );
};

const mapStateToProps = (state: State) => {
  return {
    communicationData: communicationData$(state),
    isLoading: isLoadingCommunication$(state),
    hasCommunicationData: hasCommunicationData$(state),
  };
};

const mergeProps = (stateProps, dispatchProps: DispatchProps, props: OwnProps): Props => {
  return {
    ...stateProps,
    communicationMountTab: dispatchProps.communicationMountTab,
    ...props,
  };
};

export default connect(
  mapStateToProps, {
    communicationMountTab: CommunicationCreator.communicationMountTab,
  }, mergeProps
)(Communication);
